import { JobItem, JobParticipantEnum } from 'domains/workspaceDomain';
import { useOrg, useUser } from 'hooks';
import { useAppSelector } from 'app/hooks';
import { isSaasOrSaasCustomerOrg } from 'domains/orgDomain';

const { PRODUCER, PROXY, CUSTOMER } = JobParticipantEnum;

const useShowUploadFileFlag = ({
  customerId,
  skipArtFile,
  participants,
  jobFilesEditable,
}: JobItem) => {
  console.log('useShowUploadFileFlag called with jobId:', customerId);
  console.log('Participants:', participants);
  console.log('skipArtFile:', skipArtFile);
  console.log('jobFilesEditable:', jobFilesEditable);
  const user = useUser();
  const org = useOrg();
  const orgList = useAppSelector((state) => state.org.list);

  console.log('Current user', user);
  console.log('Current org', org);

  if (participants.includes(PRODUCER)) {
    return (
      ((participants.includes(CUSTOMER) || participants.includes(PROXY)) &&
        !skipArtFile) ||
      jobFilesEditable
    );
  }

  // 如果是SAAS组织或者是SAAS人员切换到Customer组织的情况
  if (isSaasOrSaasCustomerOrg(org, orgList)) {
    return !skipArtFile || jobFilesEditable;
  }

  return (customerId === user?.userId && !skipArtFile) || jobFilesEditable;
};

export default useShowUploadFileFlag;
